import React, { useState } from 'react';
import { connect, useSelector } from 'react-redux';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { addExtras } from 'apps/auth/actions/extraAction';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import AccountLinkingScreen from 'apps/auth/components/ga/cards/order/AccountLinkingScreen';
import PinCreateScreen from 'apps/auth/components/ga/cards/order/plastic/PinCreateScreen';
import PreviewLinkScreen from 'apps/auth/components/ga/cards/order/plastic/PreviewLinkScreen';
import BasePage from 'apps/auth/components/utils/BasePage';
import ModalWithTimer from 'apps/auth/components/utils/ModalWithTimer';
import { GA_ORDER_PLASTIC_CARD_PIN } from 'apps/auth/constants/formName';
import { AUTH_GA_CARD, AUTH_GA_CARDS } from 'apps/auth/constants/UrlConstants';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';
import { FAILED, LINK, PIN, PREVIEW_LINK, requestOrderPlastic, SUCCESS } from 'apps/auth/services/GaCardsService';

const NeedPinPage = (props) => {
    const [screen, setScreen] = useState(PIN);
    const { createPinTitle, accountLinkingTitle, accountLinkingSubTitle, plastic, messageCardLinked, OhWentWrong, goBack } = usePageMessages();
    const { form = {} } = useSelector((state) => state);
    const { card, accounts } = useExtra();
    const formName = GA_ORDER_PLASTIC_CARD_PIN;

    const onClickSuccess = () => {
        window.location.href = AUTH_GA_CARD + card?.id;
    };

    const onClickHandlerPinCreate = () => {
        const helper = {
            fields: form[formName]?.fields,
            toggleSpinner: props.toggleSpinner,
            setScreenSuccess: function () {
                setScreen(PREVIEW_LINK);
            },
            setScreen,
            addExtras: props.addExtras,
            url: `${AUTH_GA_CARD}${card.id}/create/pin`,
        };
        requestOrderPlastic(helper);
    };
    const render = (currentScreen) => {
        switch (currentScreen) {
            case PIN:
                return <PinCreateScreen title={createPinTitle} backUrl={AUTH_GA_CARDS} formName={formName} onClickCreateLater={onClickHandlerPinCreate} />;
            case PREVIEW_LINK:
                return <PreviewLinkScreen onClickHandler={() => setScreen(LINK)} />;
            case LINK:
                return (
                    <AccountLinkingScreen
                        title={accountLinkingTitle}
                        subTitle={accountLinkingSubTitle}
                        isPurple={true}
                        cardText={plastic}
                        accounts={accounts}
                        setScreen={setScreen}
                        setScreenSuccess={() => setScreen(SUCCESS)}
                        url={`${AUTH_GA_CARD}${card.id}/link/account/`}
                    />
                );
            case SUCCESS:
                return <ModalWithTimer text={messageCardLinked} onClick={onClickSuccess} />;
            case FAILED:
                return (
                    <InfoPage
                        insideModalComponent={false}
                        animatedIconFail
                        headerText={OhWentWrong}
                        primaryButtonType="link"
                        primaryButtonCaption={goBack}
                        primaryButtonLink={AUTH_GA_CARDS}
                    />
                );
            default:
                return null;
        }
    };
    return render(screen);
};
export default connect(null, { toggleSpinner, addExtras })(BasePage(NeedPinPage));
